import LayoutContainer from "../../container/layout";

const LayoutView = () => {
    return <LayoutContainer />;
};

export default LayoutView;
